import React, { useState } from "react";
import * as styles from "./LoginForm.module.css";
import { LoginFormLabels, LoginFormTypes } from ".";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { ComponentProps } from "../../../types";
import { DigitalBankingForm } from "./DigitalBankingForm";
import { EBusinessForm } from "./eBusinessForm";
import { OfflineMsg } from "./OfflineMsg";

export interface LoginForm {
  formType: LoginFormTypes;
  formLabel: string;
  message?: string;
  url?: string;
}

export interface LoginFormStyle {
  style?: "light" | "dark";
}
interface Props extends ComponentProps, LoginFormStyle {
  forms: LoginForm[];
  prefix?: string;
}

export const LoginForm: React.FC<Props> = ({
  forms,
  style = "light",
  prefix = "",
  ...props
}) => {
  const formTypes: string[] = [];
  forms.forEach((form) => {
    if (form.formType && formTypes.includes(form.formType)) return;
    formTypes.push(form.formType);
  });
  const [selectedForm, setSelectedForm] = useState(
    formTypes[0] as LoginFormTypes
  );

  const handleFormSelectorChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    event.preventDefault();

    if (typeof window != undefined) {
      switch (event.target.value) {
        case "digital_banking":
          setSelectedForm(event?.target?.value as LoginFormTypes);
          break;
        case "e_business":
          setSelectedForm(event?.target?.value as LoginFormTypes);
          break;
        /* following 3 for backwards compatibility */
        /* links can now be entered as custom_sign_in links instead */
        case "wealth_management":
          getSelectedForm("wealth_management")?.message
            ? setSelectedForm(event?.target?.value as LoginFormTypes)
            : window.open(
                "https://login2.fisglobal.com/idp/TSS114/?ClientID=WebLinkUI",
                "_blank"
              );
          break;
        case "loan_portal":
          getSelectedForm("loan_portal")?.message
            ? setSelectedForm(event?.target?.value as LoginFormTypes)
            : window.open("https://emprisebank.force.com/", "_blank");
          break;
        case "credit_card":
          getSelectedForm("credit_card")?.message
            ? setSelectedForm(event?.target?.value as LoginFormTypes)
            : window.open(
                "https://www.myaccountaccess.com/onlineCard/login.do?theme=elan1&loc=29512",
                "_blank"
              );
          break;
        /* previous 3 for backwards compatibility */
        default:
          const customForm = forms.find(
            (form) => form.formLabel === event?.target?.value
          );
          if (customForm) {
            if (customForm?.message) {
              setSelectedForm(event?.target?.value as LoginFormTypes);
            } else {
              window.open(customForm?.url, "_blank");
            }
          }
      }
    }
  };

  const renderSelectedForm = () => {
    switch (selectedForm) {
      case "digital_banking":
        return <DigitalBankingForm style={style} prefix={prefix} />;
      case "e_business":
        return <EBusinessForm style={style} prefix={prefix} />;
      default:
        return <></>;
    }
  };

  const renderSelector = () => {
    return forms.map((form, idx) => (
      <option
        value={
          form.formType === "custom_sign_in" ? form.formLabel : form.formType
        }
        key={`formSelct-${idx}`}
      >
        {form.formLabel}
      </option>
    ));
  };

  const getSelectedForm = (formValue: string) => {
    return forms.find(
      (form) => form.formType === formValue || form.formLabel === formValue
    );
  };

  return (
    <SectionWrapper {...props}>
      <div
        className={`${styles.loginform} ${style === "dark" ? styles.dark : ""}`}
      >
        {formTypes.length > 1 ? (
          <div className={styles.selectorWrapper}>
            <select value={selectedForm} onChange={handleFormSelectorChange}>
              {renderSelector()}
            </select>
          </div>
        ) : (
          <div className={styles.formName}>
            {getSelectedForm(selectedForm)?.formLabel}
          </div>
        )}
        {getSelectedForm(selectedForm)?.message && (
          <OfflineMsg message={getSelectedForm(selectedForm)?.message} />
        )}
        {renderSelectedForm()}
      </div>
    </SectionWrapper>
  );
};
